// React Confirm Alert
import "react-confirm-alert/src/react-confirm-alert.css"

// Lightbox
import "react-image-lightbox/style.css"
// Bootstrap
import "bootstrap/dist/css/bootstrap.min.css"

// Local Styles
import "./src/styles/global.scss"

// Firebase
import "firebase/auth"
import "firebase/database"

// Set up Redux
import wrapWithProvider from "./wrap-with-provider"
export const wrapRootElement = wrapWithProvider
